import { render, staticRenderFns } from "./ComparePlansSection.vue?vue&type=template&id=3f902998&scoped=true&"
import script from "./ComparePlansSection.vue?vue&type=script&lang=js&"
export * from "./ComparePlansSection.vue?vue&type=script&lang=js&"
import style0 from "./ComparePlansSection.vue?vue&type=style&index=0&id=3f902998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f902998",
  null
  
)

export default component.exports